const Hospedagem = () => {
  return window.location.replace(
    'https://sigevent.pro/merkator/hospedagem/solicitacaowebempresa/index.php?id_edicao=403'
  );
};

export default Hospedagem;
